import produce from 'immer'
import { SET_TRIPS, SET_TRIP_ACTIVITIES } from './actionTypes'

export const initialState = {
  trips: {
    data: [],
    count: null,
  },
}

const tripReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_TRIPS:
        draft.trips = action.data
        break
    }
  })

const tripActivityReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_TRIP_ACTIVITIES:
        draft.data = action.data
        break
    }
  })

export default tripReducer
